<script>
export default {
  name: 'Header',
  props: {
    hasPreview: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div class="header">
    <div class="header_logo">
      <img src="@/assets/images/background/bg_header_logo.svg"/>
    </div>
    <div class="header_tlt">
      <h1 :class="[{ 'has-preview': hasPreview }]"><slot></slot></h1>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'header.scss';
</style>
